import React from "react"

const FeatureDivider = () => (
  <div
    style={{
      width: `100%`,
      marginBottom: `1rem`,
      display: `block`,
      border: `0`,
      backgroundColor: `#000000`,
      height: `1px`,
    }}
  >
  </div>
)

export default FeatureDivider